import React from 'react';
import DynamicIcon from './dynamic-icon';
import ComingSoonText from './coming-soon-text';

const DropdownOptionItem = React.forwardRef(({ children, onClick, onMouseDown, additionalclasses, isDisabled, wrapChild=false, icon, tag, description, isActive, secondaryIcon, iconSize, secondaryIconClick, secondaryTag, isDropdown, dropdownStatus, iconColor }, ref) => {
    return (
        <div ref={ref}
            onClick={!isDisabled && !isActive ? onClick : undefined}
            onMouseDown={!isDisabled && !isActive ? onMouseDown : undefined}
            className={`${isDisabled ? 'cursor-not-allowed ' : 'cursor-pointer'} dropdown-option flex items-center gap-[12px] justify-between px-[16px] m-auto w-[98%] py-[8px] w-full hover:bg-grey-50 dark:hover:bg-white-dark-200 leading-[21px] poppins-regular text-[14px] custom-text-grey-900 hover:custom-text-grey-500 rounded-[8px] ${isActive ? 'bg-grey-50 dark:bg-white-dark-200' : ''} ${additionalclasses}`}
        >
            <div className='grid gap-[2px]'>
                <div className='flex justify-between items-center gap-[4px]'>
                    <div className={`flex items-center gap-[8px] justify-start ${wrapChild ? 'whitespace-pre-wrap break-all' : 'whitespace-nowrap'} `}>
                        {icon && <DynamicIcon name={icon} size={18} color={iconColor} />}
                        {children}
                    </div>
                    {tag && <ComingSoonText>{tag}</ComingSoonText>}
                </div>
                {description && <span className='text-[12px] custom-text-grey-400 poppins-regular leading-[16px] whitespace-nowrap'>{description}</span>}
            </div>
            {secondaryIcon && <DynamicIcon name={secondaryIcon} size={iconSize} onClick={() => { secondaryIconClick() }} />}
            {isActive && <DynamicIcon name='check' size={18} />}
            {secondaryTag && <ComingSoonText>{secondaryTag}</ComingSoonText>}
            {isDropdown && <DynamicIcon name={dropdownStatus ? 'chevron-up' : 'chevron-down'} size={18} />}
        </div>
    );
});

DropdownOptionItem.displayName = 'DropdownOptionItem';

export default DropdownOptionItem;